(function ($) {

    $(document).ready(function () {

        $('.redesign-20 header .row nav > ul > li.transparent a').addClass('blue-border-btn');
        $('.redesign-20 header .row nav > ul > li.solid a').addClass('solid-blue-btn');
        $('.redesign-20 header .row nav > ul > li.btn a').clone().prependTo('.redesign-20 header .row .btn-wrap');

        $('.redesign-20 header .left-menu').each(function () {
            $(this).find('.items').wrapAll("<div class='text-wrap text-with-links'></div>");
            $(this).find('.nav-link').wrapAll("<div class='link-wrap text-with-links'></div>");
            $(this).find('.content-wrap').wrapAll("<div class='img-with-link'></div>");
            $(this).find('.sub-menu img').wrap("<div class='img-wrapper'></div>");
            $(this).find('.sub-menu .menu-image-title').wrap("<div class='description-wrap'></div>");
            $(this).find('.text-with-links').wrapAll("<div class='items-outer'></div>");


            var navDesc = $(this).find('.sub-menu .img-with-link .nav-desc').clone();
            $(this).find('.sub-menu .img-with-link .img-wrap .description-wrap').append(navDesc);

            var link = $(this).find('.sub-menu .img-with-link .link.content-wrap').clone();
            $(this).find('.sub-menu .img-with-link .img-wrap .description-wrap').append(link);


            $(this).find('.sub-menu .img-with-link .link.content-wrap .img-wrapper').remove();
            $(this).find('.sub-menu .img-with-link .img-wrap > .nav-desc').remove();
            $(this).find('.sub-menu .img-with-link > .link.content-wrap').remove();


        });

        $('.redesign-20 header .three-col-menu').each(function () {
            
            $(this).find('.items').wrapAll("<div class='col-wrap col-1'></div>");
            $(this).find('.internal-links').wrapAll("<div class='col-wrap col-2'></div>");
            $(this).find('.col-wrap').wrapAll("<div class='items-wrap'></div>");

            $(this).find('.core-items').wrapAll("<div class='core-items-wrap col-1'></div>");
            $(this).find('.core-items-wrap').wrapAll("<div class='items-wrap'></div>");
        });

        $('.redesign-20 header .medium-menu').each(function () {
            
            $(this).find('.items').wrapAll("<div class='col-wrap col-1'></div>");
            $(this).find('.internal-links').wrapAll("<div class='col-wrap col-2'></div>");
            $(this).find('.col-wrap').wrapAll("<div class='items-wrap'></div>");
        });


        $('.redesign-20 header nav > ul > li .left-menu:first-of-type ').addClass('active');


        // $('.redesign-20 header nav > ul > li.side-menu li:first-of-type ').addClass('active');

        $('.redesign-20 header nav > ul > li.medium-menu li:first-of-type ').addClass('active');


        $('.redesign-20 header nav > ul > li.small-menu li:first-of-type ').addClass('active');

        $('.redesign-20 header .row nav > ul > li').hover(function () {

            $(this).find(' .left-menu:first-of-type').addClass('active');
            $(this).find(' .left-menu:not(:first-of-type)').removeClass('active');

        });

        //li hover active functionality
        var activenav=$('.redesign-20 header .row nav > ul > li.active-nav');
        $('.redesign-20 header .row nav > ul > li').on('mouseleave',function (e) {
                $(e.target).parents('.redesign-20 header .row nav > ul > li').not(activenav).removeClass('active-nav');

        });
        $('.redesign-20 header .row nav > ul > li .sub-menu li').hover(function () {
            var ths= $(this).parents('li');
            ths.addClass('active-nav');
            $('.redesign-20 header .row nav > ul > li').not(activenav).not(ths).removeClass('active-nav');
        });


        $('.redesign-20 header .row nav > ul > li.small-menu li').hover(function () {

            $(this).addClass('active');
            $('.redesign-20 header .row nav > ul > li.small-menu li').not(this).removeClass('active');

        });

        $('.redesign-20 header .row nav > ul > li .sub-menu .left-menu').on('mouseover', function () {
            
            $(this).addClass('active');
            $('.redesign-20 header .row nav > ul > li .sub-menu .left-menu').not(this).removeClass('active');

        });

        $('.redesign-20 header .row nav > ul > li .sub-menu .left-menu').on('click', function () {


            $(this).addClass('active');
            $('.redesign-20 header .row nav > ul > li .sub-menu .left-menu').not(this).removeClass('active');

        });
        
        // $('.redesign-20 header .row nav > ul > li.side-menu li').hover(function () {

        //     $(this).addClass('active');
        //     $('.redesign-20 header .row nav > ul > li.side-menu li').not(this).removeClass('active');

        // });

        $('.redesign-20 header .row nav > ul > li.medium-menu li').hover(function () {

            $(this).addClass('active');
            $('.redesign-20 header .row nav > ul > li.medium-menu li').not(this).removeClass('active');

        });

        $('.redesign-20 header .row nav > ul > li.three-col-menu .col-wrap li').hover(function () {
            $(this).addClass('active');
            $('.redesign-20 header .row nav > ul > li.three-col-menu .col-wrap li').not(this).removeClass('active');
        });

        $('.redesign-20 header .row nav > ul > li.three-col-menu .items-wrap li').hover(function () {
          $(this).addClass('active');
          $('.redesign-20 header .row nav > ul > li.three-col-menu .items-wrap li').not(this).removeClass('active');
        });

        $('.redesign-20 header .row nav > ul > li.three-col-menu .white-btn .items-wrap li').hover(function () {
          $(this).addClass('active');
          $('.redesign-20 header .row nav > ul > li.three-col-menu .white-btn .items-wrap li').not(this).removeClass('active');
        });
        //$('.redesign-20 header .row .btn-wrap a').text().wrap('<span></span>');

     
    });

    $('.redesign-20 header .row nav > ul > li.products .sub-menu .side-menu .sub-menu .nav-desc').each(function () { 
        var Desc = $(this).clone();
        $(this).parent().find('>a').append(Desc);
    });

    var clonedWhiteBtnAppended = false; 

    function cloneWhiteBtn() {
      var clonedWhiteBtn = $('.redesign-20 header .row nav > ul > li.products .white-btn').clone();
  
      $('.redesign-20 header .row nav > ul > li.products').append(clonedWhiteBtn);
      clonedWhiteBtnAppended = true;
    }

    function removeClonedWhiteBtn() {
      $('.redesign-20 header .row nav > ul > li.products .white-btn.cloned').remove();
      clonedWhiteBtnAppended = false;
    }
  
    $(document).ready(function() {
      function checkWindowSize() {
        if ($(window).width() < 991) {
          if (!clonedWhiteBtnAppended) {
            cloneWhiteBtn();
          }
        } else {
          removeClonedWhiteBtn();
        }
      }
  
      checkWindowSize();

      $(window).on('resize orientationchange', function() {
        setTimeout(function() {
          checkWindowSize();
        }, 500);
      });
    });
   

})(jQuery);